/* eslint-disable react/prop-types */
import React from 'react';
import { convertPropToCssClassName } from '@elliemae/ds-classnames';
import { DSTooltip, TooltipType } from '@elliemae/ds-tooltip';
import { PopperInteractions as Interaction, PopperPositions as Position } from '@elliemae/ds-legacy-popper';
import { DSIconSizes } from '@elliemae/ds-icon';
import { QueryRemove, MoreOptionsVert, QueryAdd, ParenthesisAdd } from '@elliemae/ds-icons';
import { DSButton } from '@elliemae/ds-legacy-button-v1';
import { ToolBarAnimation } from '../ToolBarAnimation/ToolBarAnimation.js';
import { DELAY_CLOSE, DELAY_OPEN, TOOLBAR_ANIMATION_DURATION } from '../helpers/constants.js';

const ConditionController = ({
  onAddFilter = () => null,
  onAddRuleContainer = () => null,
  onRemoveFilter = () => null,
  handleTooltipRow = () => null,
  buttonTriggerSize = DSIconSizes.M,
  buttonTriggerType = 'text',
  buttonActionSize = DSIconSizes.M,
  buttonActionType = 'text',
  delayClose = DELAY_CLOSE,
  delayOpen = DELAY_OPEN,
  isOpen = false,
  toolTipZIndex,
}) => {
  const { cssClassName, classNameBlock, classNameElement } = convertPropToCssClassName(
    'query-builder-condition-controller',
  );
  return (
    <div className={cssClassName}>
      <DSTooltip
        delayClose={delayClose}
        delayOpen={delayOpen}
        interactionType={Interaction.CLICK}
        isOpen={isOpen}
        onOpen={handleTooltipRow}
        placement={Position.LEFT}
        springAnimationComponent={<ToolBarAnimation duration={TOOLBAR_ANIMATION_DURATION} />}
        title={
          <div className={classNameBlock('actions')}>
            <DSTooltip
              title="Remove condition"
              triggerComponent={
                <DSButton
                  buttonType={buttonActionType}
                  className={classNameElement('remove-rule')}
                  icon={<QueryRemove />}
                  onClick={onRemoveFilter}
                  size={buttonActionSize}
                  containerProps={{
                    'data-testid': 'query-remove-button',
                  }}
                />
              }
            />

            <DSTooltip
              title="Add condition"
              triggerComponent={
                <DSButton
                  buttonType={buttonActionType}
                  className={classNameElement('add-rule')}
                  icon={<QueryAdd />}
                  onClick={onAddFilter}
                  size={buttonActionSize}
                  containerProps={{
                    'data-testid': 'query-add-button',
                  }}
                />
              }
            />

            <DSTooltip
              title="Add group"
              triggerComponent={
                <DSButton
                  buttonType={buttonActionType}
                  className={`${classNameElement('add-rule-container')} no-border-right`}
                  icon={<ParenthesisAdd />}
                  onClick={onAddRuleContainer}
                  size={buttonActionSize}
                  containerProps={{
                    'data-testid': 'parenthesis-add-button',
                  }}
                />
              }
            />
          </div>
        }
        tooltipType={TooltipType.TOOLBAR}
        triggerComponent={
          <DSButton
            buttonType={buttonTriggerType}
            icon={<MoreOptionsVert color={['neutral', '500']} />}
            onClick={handleTooltipRow}
            size={buttonTriggerSize}
            containerProps={{
              'data-testid': 'condition-more-options-button',
            }}
          />
        }
        zIndex={toolTipZIndex}
      />
    </div>
  );
};

export default ConditionController;
